<template lang="pug">
  extends TableRowBase.pug
</template>

<script>
  import TableRowBase from './TableRowBase.vue';

  export default {
    name: 'TableRowNumAudiogramsByAudiologist',
    extends: TableRowBase,
    methods: {
      getCalculatedYtd(yearObj, throughMonth) {
        return this.getRatio(
          this.getYtdByField(yearObj, 'number_audiograms', throughMonth),
          this.getYtdByField(yearObj, 'number_providers', throughMonth),
        );
      },
    },
  };
</script>
